import './Scsp.scss';
import expo_img from "../assets/img/AIEXPO_Logo_Color_Horizontal_Tagline.svg";


export const Scsp = () => {
  

    return (
        <div className="container-scsp"
            style={{
                background: 'linear-gradient(to bottom, #000000, #041260, #7834D6)'
            }}
        >
            <div className="main-content">

                <div className="ai-expo-scsp-wrapper">
                    <img src={expo_img}/>
                    <div className="registor-button-wrapper">
                        <a href="https://web.cvent.com/event/29da4706-939c-49d6-96e7-c8ec6cebb5b0/regProcessStep1?RefId=GeneralAttendee&_gl=1*1a6v17n*_gcl_au*NDIxNDgzNTA2LjE3NDQ5MzQ3MTM.&utm_campaign=aiexpo25&utm_content=reg-button&utm_medium=ooh&utm_source=outfront&rp=0613bdf4-933e-4ed0-b720-63fda91036ce" target="_blank" className="register-button">Register Here</a>
                    </div>
                </div>
                <div className="text-section">
                    <p>
                        <span className="yellow-bold">SCSP 2025 AI+ Expo</span> is all about: aligning policy and products to deliver on the potential now—
                        positioning integrated <span className="white-bold">AI-powered predictive decision support</span> capabilities to help U.S. and allied
                        decision-makers act faster and smarter in a world where speed and clarity define strategic advantage.
                    </p>
                    <br />
                    <p>
                        We are excited to deepen our work with SCSP this time as the SCSP AI Expo’s <span className="white-bold">Visionary Sponsor</span>.
                        <a href="https://www.prnewswire.com/news-releases/rhombus-power-is-top-sponsor-of-scsps-ai-expo-302417799.html" target="_blank" className="read-more">Read More Here</a>
                    </p>
                    <br />
                    <p className="mt-3">See you in June!</p>
                </div>
            </div>
        </div>
    )
}

